import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-8 col-md-7" }
const _hoisted_3 = { class: "col-lg-4 col-md-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileCover = _resolveComponent("ProfileCover")!
  const _component_ProfileMenu = _resolveComponent("ProfileMenu")!
  const _component_AboutMe = _resolveComponent("AboutMe")!
  const _component_Followers = _resolveComponent("Followers")!
  const _component_MyProjects = _resolveComponent("MyProjects")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ProfileCover),
    _createVNode(_component_ProfileMenu),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AboutMe)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Followers)
      ])
    ]),
    _createVNode(_component_MyProjects)
  ]))
}